import React from 'react';

import { Button, Modal } from '@/components';
import { PinInput } from '@/components/pin-input';
import { useTranslation } from 'react-i18next';

import styles from './Modals.module.css';

interface OtpModalProps {
  onChange: (data: string[]) => void;
  onNext: () => void;
  onClose: () => void;
  isLoading: boolean;
}

function OtpModal({ onNext, onClose, onChange, isLoading }: OtpModalProps) {
  const { t } = useTranslation();

  return (
    <Modal modalStyles={{ maxWidth: '480px' }} handleClose={onClose}>
      <div className={styles.modal}>
        <h2 className={`${styles.modalTitle} ${styles.BottomMarginSm}`}>
          {t('account.verification.title')}
        </h2>
        <div className={`${styles.modalDescription} ${styles.mb40}`}>
          {t('account.verification.description')}
        </div>

        <div className={styles.modalBody}>
          <PinInput
            label={t('account.verification.label')}
            required
            length={4}
            onChange={onChange}
          />
        </div>
        <div className={styles.modalButton}>
          <Button theme="cta" onClick={onNext} isLoading={isLoading}>
            {t('account.verification.button')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default OtpModal;
